module.exports = "<span #fileInputParent>\n  <input type=\"file\" multiple/>\n</span>\n\n"


//////////////////
// WEBPACK FOOTER
// D:/desv/producao/hc/angular/adminHC/src/app/file-upload/file-upload.component.html
// module id = ../../../../../src/app/file-upload/file-upload.component.html
// module chunks = main